import { Button, Checkbox, Dialog, DialogActions, DialogContent, MenuItem, TextField } from "@mui/material";
import AttachmentInput from '../../../components/AttachmentInput';
import { Component } from "react";
import DialogTitleWithCloseButton from '../../../components/DialogTitleWithCloseButton';
import { AGENT_TYPE, DOCUMENT_NAME, GENDER } from "../../../../../shared/constants";
import { errorToast } from '../../../toast';
import { showLoading, hideLoading } from "../../../loading";
import request from '../../../request';
import swal from 'sweetalert';
import { returnChangedAttributes } from "../../../utils";


export default class Editor extends Component {

   state = {
      isPerson: true,
      type: '',
      name: '',
      surname: '',
      email: '',
      gender: '',
      phone: '',
      dob: '',
      national_id: '',
      address: '',
      attachments: Object.values(DOCUMENT_NAME.AGENT).map(name => ({
         name,
         base64: '',
         ext: '',
         fileName: ''
      }))
   }

   submit = async () => {
      
      // extract
      const txtName = document.getElementById('txt-name');
      const txtSurname = document.getElementById('txt-surname');
      const txtGender = document.getElementById('txt-gender');
      const txtPhone = document.getElementById('txt-phone');
      const txtDOB = document.getElementById('txt-dob');
      const txtNationalID = document.getElementById('txt-national-id');
      const txtAddress = document.getElementById('txt-address');
      const txtType = document.getElementById('txt-type');

      const { isPerson, name, surname, email, gender, phone, dob, national_id, address, attachments } = this.state;
      const type = this.props.type || this.state.type;

      // validate
      if (!name) {
         errorToast("Provide name");
         return txtName.focus();
      }

      if (isPerson && !surname) {
         errorToast("Provide surname");
         return txtSurname.focus();
      }

      if (isPerson && !gender) {
         errorToast("Select gender");
         return txtGender.focus();
      }

      if (isPerson && !phone) {
         errorToast("Provide phone number");
         return txtPhone.focus();
      }

      if (isPerson && !dob) {
         errorToast("Provide date of birth");
         return txtDOB.focus();
      }

      if (isPerson && !national_id) {
         errorToast("Provide national ID number");
         return txtNationalID.focus();
      }

      if (isPerson && !address) {
         errorToast("Provide address");
         return txtAddress.focus();
      }

      if (!type) {
         errorToast("Select agent type");
         return txtType.focus();
      }

      if (!this.isInEditMode()) {
         for (const attachment of attachments) {
            if (!attachment.base64) {
               errorToast(`Attach ${attachment.name}`);
               return;
            }
         }
      }

      // submit
      try {

         showLoading();

         let data = {
            is_person: isPerson,
            type,
            name,
         }

         if (email) data.email = email;
         if (phone) data.phone = phone;
         if (address) data.address = address;

         if (isPerson) {
            data.gender = gender;
            data.surname = surname;
            data.national_id = national_id;
            data.dob = dob;
         }
         
         let url = '/api/general/agents', method;

         if (this.isInEditMode()) {
            url = `${url}/${this.props.agentBeingEdited._id}`;
            method = 'patch';

            data = returnChangedAttributes(data, this.props.agentBeingEdited);

            if (data['dob']) {
               // check if date really changed
               if (data['dob'] === this.props.agentBeingEdited.dob.split('T')[0]) {
                  delete data['dob'];
               }
            }

            if (Object.keys(data).length === 0) {
               errorToast("No changes made");
               return;
            }

         } else {
            url = '/api/general/agents';
            method = 'post';
            data.attachments = attachments.map(attachment => ({
               name: attachment.name,
               base64: attachment.base64,
               ext: attachment.ext
            }));
         }

         const res = await request({
            url,
            method,
            data
         });

         this.props.onClose(res.data);
         
      } catch (err) {
         swal("Error", err.toString(), "error");
      } finally {
         hideLoading();
      }
   }

   isInEditMode = () => {
      return !!this.props.agentBeingEdited;
   }

   componentDidMount() {
      if (this.isInEditMode()) {
         const { isPerson, name, surname, email, gender, phone, national_id, address, type } = this.props.agentBeingEdited;
         const dob = this.props.agentBeingEdited.dob?.split('T')[0] || '';
         this.setState({ isPerson, name, surname, gender, email, phone, dob, national_id, address, type });
      }
   }


   render() {
      return <Dialog open fullWidth maxWidth="sm">
         <DialogTitleWithCloseButton onClose={this.props.onClose}>
            {this.isInEditMode() ? "Edit" : "Add"} Agent
         </DialogTitleWithCloseButton>
         <DialogContent dividers>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
               <div className="col-span-full flex items-center">
                  <Checkbox
                     checked={this.state.isPerson}
                     onChange={e => this.setState({ isPerson: e.target.checked })}
                     disabled={this.isInEditMode()}
                  />
                  <span className="ml-2">This is a person</span>
               </div>
               <TextField
                  id="txt-name"
                  label="Name"
                  fullWidth
                  variant="outlined"
                  size="small"
                  value={this.state.name}
                  onChange={e => this.setState({ name: e.target.value })}
                  className={!this.state.isPerson ? "col-span-full" : ""}
               />
               {
                  this.state.isPerson && <TextField
                     id="txt-surname"
                     label="Surname"
                     fullWidth
                     variant="outlined"
                     size="small"
                     value={this.state.surname}
                     onChange={e => this.setState({ surname: e.target.value })}
                  />
               }
               <TextField
                  id="txt-email"
                  label="Email"
                  fullWidth
                  variant="outlined"
                  size="small"
                  value={this.state.email}
                  onChange={e => this.setState({ email: e.target.value })}
               />
               {
                  this.state.isPerson && <TextField
                     id="txt-gender"
                     label="Gender"
                     fullWidth
                     variant="outlined"
                     size="small"
                     select
                     value={this.state.gender}
                     onChange={e => this.setState({ gender: e.target.value })}
                     className="capitalize"
                  >
                     {
                        Object
                        .values(GENDER)
                        .map(
                           gender => <MenuItem value={gender} key={gender} className="capitalize">
                           {gender}
                           </MenuItem>
                        )
                     }
                  </TextField>
               }
               <TextField
                  id="txt-phone"
                  label="Phone"
                  fullWidth
                  variant="outlined"
                  size="small"
                  value={this.state.phone}
                  onChange={e => this.setState({ phone: e.target.value })}
               />
               {
                  this.state.isPerson && <>
                     <TextField
                        id="txt-dob"
                        label="Date of Birth"
                        fullWidth
                        variant="outlined"
                        size="small"
                        type="date"
                        slotProps={{
                           inputLabel: { shrink: true }
                        }}
                        value={this.state.dob}
                        onChange={e => this.setState({ dob: e.target.value })}
                     />
                     <TextField
                        id="txt-national-id"
                        label="National ID"
                        fullWidth
                        variant="outlined"
                        size="small"
                        value={this.state.national_id}
                        onChange={e => this.setState({ national_id: e.target.value })}
                     />
                  </>
               }
               <TextField
                  id="txt-address"
                  label="Address"
                  fullWidth
                  variant="outlined"
                  size="small"
                  multiline
                  value={this.state.address}
                  onChange={e => this.setState({ address: e.target.value })}
               />
               {
                  !this.props.type && <TextField
                     id="txt-type"
                     label="Type"
                     fullWidth
                     variant="outlined"
                     size="small"
                     select
                     value={this.state.type}
                     onChange={e => this.setState({ type: e.target.value })}
                     className="capitalize"
                     disabled={this.isInEditMode()}
                  >
                     {
                     Object
                        .values(AGENT_TYPE)
                        .map(
                        type => <MenuItem value={type} key={type} className="capitalize">
                           {type}
                        </MenuItem>
                        )
                     }
                  </TextField>
               }
               {
                  !this.isInEditMode() && <div className="col-span-full">
                     {
                        this.state.attachments.map(({ name }, i) => <AttachmentInput
                           key={i}
                           label={name}
                           name={this.state.attachments?.[i]?.fileName}
                           onChange={file => {
                              const attachments = this.state.attachments.map(item => {
                                 if (name !== item.name)
                                    return item;
                                 return {
                                    ...item,
                                    base64: file?.base64,
                                    ext: file?.ext,
                                    fileName: file?.name
                                 }
                              });

                              this.setState({ attachments });
                           }}
                        />)
                     }
                  </div>
               }
            </div>
         </DialogContent>
         <DialogActions>
         <Button variant="contained" onClick={this.submit}>
            SAVE
         </Button>
         </DialogActions>
      </Dialog>
   }
}